import LocationUtil from "./common/util/LocationUtil";
import Top from "./top/Top";
import Quiz from "./quiz/Quiz";
import Result from "./result/Result";

class App {
  // ---------------------------------------------------------------------------------------------------------
  // --	App
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    //自信参照
    const holder = this;

    // debug, test パラメータ指定がない場合は、console.log 出力を行わないように
    if (!LocationUtil.getParam("debug")) {
      console.log = function () {
        // do nothing.
      };
    }

    //VIEWPORTの設定
    var ua = navigator.userAgent;
    if (
      ua.indexOf("iPhone") > 0 ||
      ua.indexOf("iPod") > 0 ||
      (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
    ) {
      $("head").prepend(
        '<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">'
      );
    } else {
      $("head").prepend(
        '<meta name="viewport" content="width=1366, target-densitydpi=device-dp, user-scalable=no, shrink-to-fit=no">'
      );
    }

    //ローディング判定用のフラグ
    this.isLoaded = false;
    this.fontIsLoaded = false;

    //フォント読み込み
    window.onload = () => {
      WebFont.load({
        custom: { families: ["Noto Sans JP"] },
        loading: () => {},
        active: () => {
          holder.fontIsLoaded = true;
          holder.onLoad();
        },
        inactive: () => {},
      });
    };

    //準備完了
    $(document).ready(this.onReady.bind(this));

    //ロード完了
    $(window).on("load", () => {
      this.isLoaded = true;
      this.onLoad();
    });

    //ブラウザバック
    window.onpageshow = function (event) {
      if (event.persisted) {
        location.reload();
      }
    };
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	初期化
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 準備
   */
  onReady() {}

  // ---------------------------------------------------------------------------------------------------------
  // --	Load完了
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ロード済み
   */
  onLoad() {
    console.log("onLoad ---- " + this.isLoaded + " - " + this.fontIsLoaded);

    if (!this.isLoaded || !this.fontIsLoaded) return;

    if ($(".pg-top").length > 0) {
      new Top();
    } else if ($(".pg-quiz").length > 0) {
      new Quiz();
    } else if ($(".pg-result").length > 0) {
      new Result();
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

new App();
